const qualYear = {
	data: {
		current_year: 2019
	},
	errors: []
};

export default qualYear;
